import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class FlameDetectionRange {
  @Expose()
  @IsString()
  name!: string;

  @Expose()
  @IsOptional()
  @IsNumber()
  detectionRangeHigh?: number | null;

  @Expose()
  @IsNumber()
  detectionRangeDefault!: number;

  @Expose()
  @IsOptional()
  @IsNumber()
  detectionRangeLow?: number | null;

  constructor(
    name: string,
    detectionRangeDefault: number,
    detectionRangeHigh?: number | null,
    detectionRangeLow?: number | null,
  ) {
    this.name = name;
    this.detectionRangeDefault = detectionRangeDefault;
    this.detectionRangeHigh = detectionRangeHigh;
    this.detectionRangeLow = detectionRangeLow;
  }

  static create(
    name: string,
    detectionRangeDefault: number,
    detectionRangeHigh?: number | null,
    detectionRangeLow?: number | null,
  ): FlameDetectionRange {
    return new FlameDetectionRange(name, detectionRangeDefault, detectionRangeHigh, detectionRangeLow);
  }
}
